import { render, staticRenderFns } from "./SelectionsPane.vue?vue&type=template&id=70fa03ca"
import script from "./SelectionsPane.vue?vue&type=script&lang=js"
export * from "./SelectionsPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports